/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import _ from 'lodash';
import React from 'react';

import { Grid, Form } from '@mairistem/composants';

import { AdresseForm } from '@mairistem/adresses';

import type { Adresse } from '@/types';
import { Section } from '@/components/Common';
import { formatAdresse } from '@/utils';

interface Props {
  adresseRattachement: Partial<Adresse>;
  isResideCommune: boolean;
  errors: Record<string, string>;
  onChange: (
    event: React.ChangeEvent<HTMLInputElement>,
    object: object,
  ) => void;
}

const AdresseRattachement = (props: Props) => {
  const { adresseRattachement, isResideCommune, errors, onChange } = props;

  const handleAdresseChange = React.useCallback(
    ({ adresse }) => {
      onChange(null, {
        name: 'adresseRattachement',
        value: formatAdresse(adresseRattachement, adresse),
      });
    },
    [adresseRattachement, onChange],
  );

  return (
    <Section title="ADRESSE DE RATTACHEMENT">
      <Grid padded>
        <Grid.Row verticalAlign="middle">
          <Grid.Column mobile={16} computer={4} textAlign="center">
            <Form.Checkbox
              toggle
              name="isResideCommune"
              label="Réside dans la commune"
              data-testid="assistant-checkbox-commune"
              checked={isResideCommune}
              onClick={onChange}
            />
          </Grid.Column>
          <Grid.Column mobile={16} computer={12}>
            <AdresseForm
              saisie="libre"
              displayDepartement={false}
              adresse={{
                ...adresseRattachement,
                type: 'Commune',
                codePostal: adresseRattachement?.libelleCodePostal,
                commune: adresseRattachement?.libelleCommune,
                voie: adresseRattachement?.libelleVoie,
                pays: adresseRattachement?.libellePays,
              }}
              onItemChange={handleAdresseChange}
              error={!_.isNil(errors?.adresseRattachement)}
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </Section>
  );
};

export default AdresseRattachement;
